import {fork, takeEvery} from "@redux-saga/core/effects";
import {documentType} from "../../actions/document/type";
import {postDocumentAttach} from "../../../api/common/document";

function* onPostDocumentAttachRequest() {
    yield takeEvery(documentType.POST_DOCUMENT_ATTACH_REQUEST, onPostDocumentAttachAsync);
}

function* onPostDocumentAttachAsync(action) {
    const response = postDocumentAttach(action.payload);
}

const document = [fork(onPostDocumentAttachRequest)];

export default document;